import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Anchor from '../../atoms/anchor';
import Typography from '../../atoms/typography';

const BrandSection = styled.dl`
  display: flex;
  padding: 2rem 0;

  & ~ & {
    border-top: 1px solid ${({ theme }) => theme.color.brand};
  }
`;

const Letter = styled(Typography)`
  color: ${({ theme }) => theme.color.brand};
  line-height: 1;
  width: 25%;

  && {
    font-size: ${({ theme }) => theme.modularScale.xlarge};
  }
`;

const Brand = styled(Typography)`
  color: ${({ theme }) => theme.color.brand};
  line-height: 2;
`;

const List = styled.div`
  flex: 1;

  @media screen and (min-width: ${(props) => props.theme.breakpoint.medium}) {
    column-count: 3;
  }
`;

const sortByName = (a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);

const BrandsSection = forwardRef((props, ref) => (
  <section ref={ref}>
    {
      props.keys.map((k) => (
        props.brands[k] && (
          <BrandSection key={k}>
            <Letter id={k} element="dt" like="label-1" data-section={k}>{k}</Letter>

            <List>
              {
                props.brands[k].sort(sortByName).map((brand) => (
                  <Brand key={brand.id} element="dd" like="dec-1">
                    <Anchor href={`brands/${brand.permalink.split('/')[1]}`}>
                      {brand.name}
                    </Anchor>
                  </Brand>
                ))
              }
            </List>
          </BrandSection>
        )
      ))
    }
  </section>
));

BrandsSection.defaultProps = {
  brands: {},
  keys: 'A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z,0-9,@'.split(',')
};

BrandsSection.propTypes = {
  brands: PropTypes.object,
  keys: PropTypes.array
};

BrandsSection.whyDidYouRender = true;

export default BrandsSection;
